export const LAYOUT_LEFT_RIGHT_NEW_WINDOW_PAGE_BOTTOM =
  "LAYOUT_LEFT_RIGHT_NEW_WINDOW_PAGE_BOTTOM";
